import React, { useState } from "react";
import TravellerDetailsUI from "../TravellerDetails/TravellerDetailsUI";
import * as S from "./TravellerDetailsContainer.styles";
import AccordBtn from "../../../../core-components/AccordBtn/AccordBtn.styles";
import SpecialRequestUI from "../../reviewpage/SpecialRequest/SpecialRequestUI";
import { DEFAULT_CONTACT_DETAILS } from "../../../../../shared/config/constants";

interface ITravellerDetails {
  heading: string;
  infoText: string;
  margin: string;
  login: Function;
  onUpdateTravellerDetails?: Function;
  specialRequest: object;
  travellerDetails: object;
  travellerTitle: Array<{}>;
  updateSelectedData?: Function;
  sr: Array<[]>;
  error: {};
}

const TravellerDetailsContainerUI: React.FC<ITravellerDetails> = ({
  heading,
  infoText,
  margin,
  login,
  onUpdateTravellerDetails,
  specialRequest = {},
  travellerDetails = {},
  travellerTitle = DEFAULT_CONTACT_DETAILS,
  updateSelectedData,
  sr = [],
  error = {} 
}) => {
  const [toggle, setToggle] = useState(true);

  const handlePolicy = () => {
    setToggle(!toggle);
  };

  return (
    <S.TravellerCont margin={margin}>
      <S.TravellerHeader onClick={handlePolicy}>
        <div>{heading && <h3>{heading}</h3>}</div>
        {infoText && (
          <div className="infoText" onClick={login}>
            {infoText}
          </div>
        )}
        <AccordBtn active={toggle} margin="0 0 0 2rem" />
      </S.TravellerHeader>
      {toggle && (
        <>
          <TravellerDetailsUI
            onUpdateTravellerDetails={onUpdateTravellerDetails}
            travellerDetails={travellerDetails}
            travellerTitle={travellerTitle}
            error={error}
          />
          {Object.keys(specialRequest)?.length ? (
            <SpecialRequestUI
              {...specialRequest}
              updateSelectedData={updateSelectedData}
              sr={sr}
            />
          ) : null}
        </>
      )}
    </S.TravellerCont>
  );
};

export default React.memo(TravellerDetailsContainerUI);
